export const FOCAL_POINT_IMAGES = 'focal_point_images';
export const DESIGN_AND_CUSTOMIZATION_OO = 'design_and_customization_oo';
export const DESIGN_AND_CUSTOMIZATION_CATERING =
  'catering_design_and_customization';
export const PROMO_CODE_ENHANCEMENTS_V1 = 'promo_code_enhancements_v1';

export const MENUUPSELLS = 'menu_upsells';
export const ONLINE_ORDERING_AUTOMATED_STORE_REACTIVATION =
  'online_ordering_automated_store_reactivation';
export const ONLINE_ORDERING_SEARCH = 'online_ordering_search';
export const NEXT_GEN_MENUS_MODIFIERS_MIGRATION =
  'next_gen_menus_modifiers_migration';
export const NEXT_GEN_MENUS_MULTIPLE_PRODUCT_VARIANTS =
  'next_gen_menus_multiple_product_variants';
export const NEXT_GEN_MENUS_PRODUCT_VARIANTS_MIGRATION =
  'next_gen_menus_product_variants_migration';
export const ONLINE_ORDERING_GROUP_ORDERING = 'online_ordering_group_ordering';
